import { useRecoilState } from 'recoil';
import { selectedFundState } from '../state.js';
import { FundChip } from './FundChip.js';
import { cn } from '../utils.js';
import type { FundCurrency } from '@agio/core/domain';

export interface FundOption {
  fund_id: string;
  fund_name: string;
  is_old: boolean;
  /** The currency the fund's figures are in, as an admin set it. */
  currency: FundCurrency;
  /** 'alternative' = an alternative investment fed by quarterly reports. */
  kind?: 'manager' | 'alternative';
}

/** Fund selector — chip row with manager logos: סיכום תיק (all) or a single fund. */
export function FundDropdown({ funds }: { funds: FundOption[] }) {
  const [selected, setSelected] = useRecoilState(selectedFundState);
  // Server already filters to customer-visible funds (is_visible).
  const active = funds;

  return (
    // Carousel: single row, horizontal scroll + snap when space runs out — never wraps/jerks.
    // chip-fade paints a gradient over the overflow edge so it reads as scrollable.
    <div className="chip-fade relative min-w-0 flex-1">
      <div className="chip-scroll flex snap-x items-center gap-2 overflow-x-auto py-1 pb-1.5">
      <button
        type="button"
        onClick={() => setSelected(null)}
        className={cn(
          'shrink-0 snap-start rounded-full border px-3 py-1.5 text-sm font-medium transition-colors',
          selected === null ? 'border-ring bg-muted text-foreground' : 'border-border text-muted-foreground hover:bg-muted/60',
        )}
      >
        סיכום תיק
      </button>
      {active.map((f) => (
        <FundChip
          key={f.fund_id}
          name={f.fund_name}
          active={selected === f.fund_id}
          onClick={() => setSelected(selected === f.fund_id ? null : f.fund_id)}
        />
      ))}
      </div>
    </div>
  );
}
